import { Select, Space, TimePicker, Tooltip } from "antd";
import dayjs from "dayjs";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import { useContext } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

export function InputSelect({
	id,
	name,
	label,
	placeholder,
	options,
	value,
	onChange,
	onBlur,
	formstyle = "",
	touched,
	errors,
	allowClear = true,
	showSearch = true,
	maxTagCount = "responsive",
	mode,
	loading,
	defaultValue,
	searchLabelBoolean,
	disabled = false,
	infoTooltip,
	optionRender,
	width = "100%",
	onSelect,
	onDeselect,
	onClear,
}) {
	const FormError = errors && touched ? "form-error" : "";

	return (
		<div className={`position-relative ${formstyle} ${FormError}`}>
			{label && (
				<label className="form-label text-capitalize">
					{trans(label)}{" "}
					{infoTooltip && (
						<Tooltip title={infoTooltip}>
							<InfoCircleOutlined
								style={{ color: "#999", cursor: "pointer" }}
							/>
						</Tooltip>
					)}
				</label>
			)}
			<Space style={{ width: "100%" }} direction="vertical">
				<Select
					style={{ width: width }}
					id={id}
					name={name}
					placeholder={trans(placeholder)}
					value={value ?? undefined}
					options={options}
					allowClear={allowClear}
					showSearch={showSearch}
					maxTagCount={maxTagCount}
					status={touched && errors ? "error" : ""}
					onChange={onChange}
					onSelect={onSelect}
					onDeselect={onDeselect}
					onBlur={onBlur}
					filterOption={(input, option) =>
						searchLabelBoolean
							? option?.searchLabel?.toLowerCase().includes(input.toLowerCase())
							: option?.label?.toLowerCase().includes(input.toLowerCase())
					}
					mode={mode ? mode : undefined}
					loading={loading ? loading : false}
					defaultValue={defaultValue ? defaultValue : undefined}
					disabled={disabled}
					notFoundContent={trans("No Data")}
					dropdownStyle={{ textTransform: "capitalize" }}
					optionRender={optionRender ?? undefined}
					onClear={onClear}
				/>
			</Space>
			{errors && touched && <div className="validation">{trans(errors)}</div>}
		</div>
	);
}

export function ShiftSelect({ value, onChange, onBlur, errors, touched }) {
	const { setOpenShiftPopup } = useContext(popupcontext);

	const shiftOptions = [
		{ label: "Morning", value: "morning" },
		{ label: "Evening", value: "evening" },
		{ label: "Night", value: "night" },
	];

	return (
		<div className="form-input">
			<label className="form-label">{trans("Shift")}</label>
			<Select
				id="shift"
				name="shift"
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				style={{ width: "100%" }}
				placeholder="Select Shift"
				options={shiftOptions}
				dropdownRender={(menu) => (
					<>
						{menu}
						<div
							style={{
								padding: "8px",
								cursor: "pointer",
								borderTop: "1px solid #eee",
							}}
							onMouseDown={(e) => {
								e.preventDefault();
								setOpenShiftPopup(true);
							}}
						>
							➕ {trans("Add new shift")}
						</div>
					</>
				)}
			/>
			{touched && errors && <div className="validation">{trans(errors)}</div>}
		</div>
	);
}

export function TimePickerInput({
	title,
	id,
	name,
	value,
	onChange,
	onBlur,
	errors,
	touched,
	formstyle,
	disabled = false,
	format = "HH:mm",
	minuteStep = 5,
	defaultTime,
}) {
	const isError = errors && touched;
	const FormError = isError ? "form-error" : "";

	const parsed = value
		? dayjs(value, format)
		: defaultTime
			? dayjs(defaultTime, format)
			: null;

	return (
		<div className={`position-relative ${formstyle} ${FormError}`}>
			{title && <label className="form-label text-capitalize">{title}</label>}

			<TimePicker
				id={id}
				name={name}
				value={parsed}
				onChange={(time) => onChange(time ? time.format(format) : "")}
				onBlur={onBlur}
				disabled={disabled}
				format={format}
				minuteStep={minuteStep}
				style={{ width: "100%" }}
				allowClear
				defaultValue={dayjs(defaultTime, format)}
				status={touched && (!value || value.length === 0) ? "error" : ""}
				placeholder={trans("Select Time")}
			/>

			{isError && <div className="validation">{trans(errors)}</div>}
		</div>
	);
}
